function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useState, useEffect } from 'react';
import { Accordion as MuiAccordion, AccordionDetails as MuiAccordionDetails, AccordionSummary as MuiAccordionSummary, Box, Typography } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { AccordionContainer, Title } from "./styles";
import { useId } from "../../hooks";
import ArrowChevronDown from "../../icons/ArrowChevronDown";
var useStyles = makeStyles(function (theme) {
  return createStyles({
    rootStyle: _defineProperty({}, theme === null || theme === void 0 ? void 0 : theme.breakpoints.down('md'), {
      borderLeftColor: 'transparent !important',
      borderRightColor: 'transparent !important',
      borderTopColor: 'transparent !important',
      borderRadius: '0 !important'
    })
  });
});
export function Accordion(_ref) {
  var items = _ref.items,
    onToggleOpen = _ref.onToggleOpen;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    openMapping = _useState2[0],
    setOpenMapping = _useState2[1];
  var _useStyles = useStyles(),
    rootStyle = _useStyles.rootStyle;
  var handleChange = useCallback(function (item) {
    return setOpenMapping(function (currentOpenMapping) {
      var id = item.id;
      var isOpening = !currentOpenMapping[id];
      var newOpenMapping = _objectSpread(_objectSpread({}, currentOpenMapping), {}, _defineProperty({}, id, isOpening));
      onToggleOpen && onToggleOpen(isOpening, item);
      return newOpenMapping;
    });
  }, [setOpenMapping, onToggleOpen]);
  useEffect(function () {
    var openMappingCopy = _objectSpread({}, openMapping);
    for (var idx = 0; idx < items.length; idx++) {
      var _item$id, _openMappingCopy$_key;
      var _item = items[idx];
      var _key = (_item$id = _item.id) !== null && _item$id !== void 0 ? _item$id : idx;
      openMappingCopy[_key] = (_openMappingCopy$_key = openMappingCopy[_key]) !== null && _openMappingCopy$_key !== void 0 ? _openMappingCopy$_key : _item.expanded || false;
    }
    setOpenMapping(openMappingCopy);
  }, [items]);
  var idPrefix = useId();
  return /*#__PURE__*/React.createElement(AccordionContainer, {
    className: rootStyle
  }, items.map(function (item, idx) {
    var _item$id2;
    var id = (_item$id2 = item.id) !== null && _item$id2 !== void 0 ? _item$id2 : idx.toString();
    var ariaPrefix = "".concat(idPrefix, "-").concat(id);
    var expanded = !!openMapping[id];
    var onChangeAccordion = function onChangeAccordion() {
      handleChange(_objectSpread(_objectSpread({}, item), {}, {
        id: id
      }));
    };
    return /*#__PURE__*/React.createElement(MuiAccordion, {
      elevation: 0,
      expanded: expanded,
      key: id,
      onChange: onChangeAccordion,
      square: true,
      disabled: !!item.disabled
    }, /*#__PURE__*/React.createElement(MuiAccordionSummary, {
      "aria-controls": "".concat(ariaPrefix, "-content"),
      expandIcon: /*#__PURE__*/React.createElement(ArrowChevronDown, null),
      id: "".concat(ariaPrefix, "-header"),
      onClick: function onClick() {
        var _item$onClick;
        return (_item$onClick = item.onClick) === null || _item$onClick === void 0 ? void 0 : _item$onClick.call(item, id, !!openMapping[id]);
      }
    }, /*#__PURE__*/React.createElement(Box, {
      alignItems: "center",
      display: "flex",
      style: {
        width: '100%'
      }
    }, !!item.icon && /*#__PURE__*/React.createElement(Box, {
      mr: 2
    }, item.icon), /*#__PURE__*/React.createElement(Title, null, item.title))), /*#__PURE__*/React.createElement(MuiAccordionDetails, null, /*#__PURE__*/React.createElement(Typography, {
      component: "div"
    }, item.content)));
  }));
}